// node_modules
import { FC, useEffect, useState } from "react";
// Components
import { PlusButton } from "Components";
import { CaseTerminology } from "./CaseTerminology";
// Types
import { TTerminologyDTO } from "Types";
// styles
import styles from "../intake.module.scss";
// Controllers
import { TerminologyControllerSingleton } from "Controllers";
// Controllers
import { ToastHelperSingleton } from "Helpers";
// Enums
import { ToastTypeEnum } from "Enums";

export type TCaseTerminologiesProps = {
    caseId: number,
    isEditMode: boolean,
    terminologies: TTerminologyDTO[]
};

export const CaseTerminologies: FC<TCaseTerminologiesProps> = ({caseId, isEditMode, terminologies}: TCaseTerminologiesProps) => {
    // State
    const [currentTerminologies, setCurrentTerminologies] = useState<TTerminologyDTO[]>([]);

    // Logic
    useEffect(() => {
        setCurrentTerminologies(terminologies);
    }, [terminologies]);

    const terminologyDeletedHandler = (terminologyDeletedId: number): void => {
        const newcurrentTerminologies: TTerminologyDTO[] = [];
        for (const currentTerminology of currentTerminologies) {
            if (currentTerminology.id !== terminologyDeletedId) {
                newcurrentTerminologies.push(currentTerminology);
            }
        }

        setCurrentTerminologies(newcurrentTerminologies);
    };

    const createEmptyTerminologyAsync = async (): Promise<void> => {
        // call server to create empty terminology
        const emptyTerminologyId: number | undefined =  await TerminologyControllerSingleton
            .createEmptyTerminologyAsync(caseId);


        // tell user about create result 
        if (!emptyTerminologyId) {
            ToastHelperSingleton.showToast(ToastTypeEnum.Error, "Was not able to create terminology.");
        } else {
            ToastHelperSingleton.showToast(ToastTypeEnum.Success, "Successfully created terminology.");

            // add empty terminology to component state
            const emptyTerminology: TTerminologyDTO = {
                id: emptyTerminologyId,
                terminology: ""
            };
            setCurrentTerminologies([...currentTerminologies, emptyTerminology]);
        }
        
        return;
    };
    
    // Render
    return (
        isEditMode ?
            <div className={styles.intakeItem}>
                <h4>Terminology</h4>
                {currentTerminologies.map((terminology: TTerminologyDTO) => {
                    return (
                        <CaseTerminology
                        key={terminology.id}
                            caseId={caseId}
                            isEditMode={true}
                            terminology={terminology}
                            terminologyDeletedHandler={terminologyDeletedHandler} />
                    );
                })}
                <PlusButton 
                    onClick={createEmptyTerminologyAsync} />
            </div>
        :
            currentTerminologies.filter((terminology: TTerminologyDTO) => terminology.terminology).length > 0 ?
                <div className={styles.intakeItem}>
                    <h4>Terminology</h4>
                    <ul>
                        {currentTerminologies
                            .filter((terminology: TTerminologyDTO) => terminology.terminology)
                            .map((terminology: TTerminologyDTO) => {
                                return (
                                    <CaseTerminology
                                        key={terminology.id}
                                        caseId={caseId}
                                        isEditMode={true}
                                        terminology={terminology} />
                                );
                        })}
                    </ul>
                </div>
            :
                null
    );
};